import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=bffc2f2c&scoped=true&"
import script from "./LoginOtp.vue?vue&type=script&lang=js&"
export * from "./LoginOtp.vue?vue&type=script&lang=js&"
import style0 from "./LoginOtp.vue?vue&type=style&index=0&id=bffc2f2c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc2f2c",
  null
  
)

export default component.exports